<template>
  <vs-wrapper>
    <AutoComplete
      v-if="fetchedTypes"
      :items="locationTypesForAutoComplete"
      :value="location.locationTypeId"
      :disabled="disabled"
      label="Location type"
      required
      :is-dialog-visible="locationType.isDialogVisible"
      @input="handleLocationUpdate({ field: 'locationTypeId', value: $event })"
      @click-add="handleAddLocationType"
      @dialog-close="handleDialogClose"
    />

    <AutoComplete
      v-if="fetchedStatuses"
      :items="statusesForAutocomplete"
      :value="location.colorId"
      :disabled="disabled"
      label="Status"
      :is-dialog-visible="status.isDialogVisible"
      @input="handleLocationUpdate({ field: 'colorId', value: $event })"
      @click-add="handleAddStatus"
      @dialog-close="handleDialogClose"
    />
  </vs-wrapper>
</template>

<script setup lang="ts">
import { sortBy } from 'lodash'
import { computed, reactive } from 'vue'
import { useGetLocationTypesQuery } from '@/api/location-types'
import AutoComplete from '@/components/common/AutoComplete.vue'
import { useGetLocationStatusesQuery } from '@/api/locations'
import VsWrapper from '@/components/vision/VsWrapper.vue'

const props = defineProps<{
  location: {
    locationTypeId?: number | null
    colorId?: number | null
    canEdit?: boolean | null
  }
}>()

const locationType = reactive({
  isDialogVisible: false,
  searchText: '',
})
const status = reactive({
  isDialogVisible: false,
  searchText: '',
})

const disabled = computed(() => !props.location.canEdit)

const { data: locationTypes, isFetched: fetchedTypes } = useGetLocationTypesQuery({
  includeUnused: true,
})

const locationTypesForAutoComplete = computed(() => {
  const types = locationTypes.value?.map((locationType) => {
    return {
      text: locationType.name,
      value: locationType.id,
      icon: locationType.iconId || 'mdi-map-marker',
    }
  })

  return sortBy(types, 'text')
})

const { data: statuses, isFetched: fetchedStatuses } = useGetLocationStatusesQuery()
const statusesForAutocomplete = computed(() => {
  return statuses.value?.map((s) => ({
    text: s.name,
    value: s.id,
    color: s.hexCode,
  }))
})

const emit = defineEmits<{
  (e: 'updated', data: { field: string; value: any }): void
}>()
function handleLocationUpdate(data: { field: string; value: any }) {
  emit('updated', data)
}
function handleDialogClose() {
  locationType.isDialogVisible = false
  status.isDialogVisible = false
}
function handleAddLocationType(value: string) {
  locationType.searchText = value || ''
  locationType.isDialogVisible = true
}
function handleAddStatus(value: string) {
  status.searchText = value || ''
  status.isDialogVisible = true
}
</script>
